import Image from 'next/image';
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { Review, SCORES } from '@/utils/api/reviews/reviews.data-model';

export default function ReviewCard({
  onReviewSelected,
  review,
  isAutoScroll,
}: {
  onReviewSelected: (review: Review) => void;
  review: Review;
  isAutoScroll: boolean;
}) {
  const router = useRouter();
  const scoreInfo = SCORES.find(s => s.value === review.score);

  const handleClick = () => {
    const isTabletOrLarger = window.matchMedia('(min-width: 768px)').matches;
    router.push(
      {
        pathname: '/game-reviews',
        query: {
          slug: review.slug,
        },
      },
      `/game-reviews/${review.slug}`,
      {
        shallow: true,
      }
    );

    if (isTabletOrLarger) {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={() => {
        handleClick();
        onReviewSelected(review);
      }}
      className="group relative flex flex-col items-center gap-2"
      key={review.slug}
    >
      <div
        style={{ textShadow: '0 0 10px #000' }}
        title={`Оценка: ${scoreInfo?.label}`}
        className="absolute right-2 top-2 z-10 hover:cursor-help"
      >
        {scoreInfo?.emoji}
      </div>

      <Image
        src={review.game.image}
        alt={review.game.name}
        width={200}
        height={100}
        placeholder="blur"
        blurDataURL={review.game.thumbnail}
        className="aspect-[15/7] w-full rounded-xl object-cover transition-all duration-200 ease-in-out group-hover:brightness-150"
      />

      <p className="line-clamp-1 text-sm">{review.game.name}</p>
    </button>
  );
}
